module.exports = __webpack_public_path__ + "static/media/arcdev2-contact.539872ac.PNG";